// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:44:41+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1454084009ebf6ee7da45c3ec95efae2
//    Signature:      eyJpdiI6ImdIRG5vd2lTNzJKVmRLZjNOMTJ6cEE9PSIsInZhbHVlIjoiaG0ydE81UHg3dVlUbUpzc1d2SHNzOHV6YzUrK0RRUEd3TTRXNXFtUVdpb1VUNlwvNlhLM3ZUc0tzUkhReFwvelFESnhJTEdcL1lXZFwvQStqNDdWK0lhWGxrclwvOXhjczFUWm9lSFkwaGp3WDZObGFXaUczTnV1Qys5ZTVjRVdyeHgzd3h5K2hzSVpYZnNKaTBXZnFnSGhHQmlINXhCRWNjM01VZTB3aGw3dStiZjBWd3diSmh5K2k0aW9BU1dMZ0VGazU3Y1puNHh1aG42cmdGa2JcL2hlajdyUHhMalUzckFKdkZ1NWU3d0plXC8wbHRHK3d6Q1JiOGNpWmVMZFh2aXJQVncxSHhwNStIZEJ2XC8xQjFqNXVPQWdNbUNkRGNtUGNJdGgzck9KUFExNDFpc0g0c3RHVnF3YVVWbzRWNG9iMnlIUVFaVGtiUENDdVBLOXZrOTh3a2tWc2M0Z1Zld09XY09CSFk4SzQ2eEg4bFwvdEYzXC9mTTNVQWRxbEVrNStpb0lGZGJOejZsNWZ4U3Vnc2tMTEVqamNibGNKWUFPbHV6MWtlanNDdTl0Q1didGc9IiwibWFjIjoiM2RhMzI1NmY4NjYyMmU2MjU5ODI4MWQ4MjYwYjA4ZDQ5MDI3M2M1NjdkZjdmODYwYTUzZDhjNGY5NGQ4NWIwOSJ9
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
